import { resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-4a1953cd")

_pushScopeId("data-v-4a1953cd")
const _hoisted_1 = { class: "nav-container" }
const _hoisted_2 = { class: "home" }
const _hoisted_3 = { class: "options-container" }
const _hoisted_4 = { class: "dropdown-container-container" }
const _hoisted_5 = /*#__PURE__*/_createTextVNode(" Algorithms ")
const _hoisted_6 = /*#__PURE__*/_createTextVNode(" Speed ")
const _hoisted_7 = /*#__PURE__*/_createTextVNode(" Cell Size ")
const _hoisted_8 = /*#__PURE__*/_createTextVNode(" Array Elements ")
const _hoisted_9 = /*#__PURE__*/_createTextVNode(" Mazes ")
const _hoisted_10 = { class: "action-buttons-container" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_SVG = _resolveComponent("SVG")
  const _component_Dropdown = _resolveComponent("Dropdown")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _createVNode(_component_SVG, {
        name: _ctx.svgNames.home,
        onClick: _ctx.sendUserHome
      }, null, 8, ["name", "onClick"])
    ]),
    _createVNode("div", _hoisted_3, [
      _createVNode("div", _hoisted_4, [
        _createVNode("div", {
          class: "dropdown-container",
          style: _ctx.algoDropdownVisible ? _ctx.dropdownStyle : _ctx.normalStyle
        }, [
          _createVNode("h1", {
            class: "is-size-4",
            onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.algoDropdownVisible = !_ctx.algoDropdownVisible))
          }, [
            _hoisted_5,
            _createVNode(_component_SVG, {
              name: _ctx.svgNames.downArrow
            }, null, 8, ["name"])
          ]),
          (_ctx.algoDropdownVisible)
            ? (_openBlock(), _createBlock(_component_Dropdown, {
                key: 0,
                dropdownItems: _ctx.algorithmsList,
                selectedAlgo: _ctx.selectedAlgo,
                onSelectionChanged: _ctx.algorithmChanged
              }, null, 8, ["dropdownItems", "selectedAlgo", "onSelectionChanged"]))
            : _createCommentVNode("", true)
        ], 4),
        _createVNode("div", {
          class: "dropdown-container",
          style: _ctx.speedDropdownVisible ? _ctx.dropdownStyle : _ctx.normalStyle
        }, [
          _createVNode("h1", {
            class: "is-size-4",
            onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.speedDropdownVisible = !_ctx.speedDropdownVisible))
          }, [
            _hoisted_6,
            _createVNode(_component_SVG, {
              name: _ctx.svgNames.downArrow
            }, null, 8, ["name"])
          ]),
          (_ctx.speedDropdownVisible)
            ? (_openBlock(), _createBlock(_component_Dropdown, {
                key: 0,
                dropdownItems: null
              }, {
                default: _withId(() => [
                  _createVNode("p", null, "Speed: " + _toDisplayString(_ctx.algoSpeed / 1000) + "s", 1),
                  _createVNode("input", {
                    type: "range",
                    min: "50",
                    max: "2000",
                    step: "50",
                    class: "slider",
                    value: _ctx.algoSpeed,
                    onChange: _cache[3] || (_cache[3] = ($event: any) => (
                                _ctx.$emit(
                                    'update:algoSpeed',
                                    parseInt($event.target.value)
                                )
                            ))
                  }, null, 40, ["value"])
                ]),
                _: 1
              }))
            : _createCommentVNode("", true)
        ], 4),
        (_ctx.cellSize)
          ? (_openBlock(), _createBlock("div", {
              key: 0,
              class: "dropdown-container",
              style: 
                        _ctx.cellSizeDropdownVisible ? _ctx.dropdownStyle : _ctx.normalStyle
                    
            }, [
              _createVNode("h1", {
                class: "is-size-4",
                onClick: _cache[4] || (_cache[4] = ($event: any) => (
                            _ctx.cellSizeDropdownVisible = !_ctx.cellSizeDropdownVisible
                        ))
              }, [
                _hoisted_7,
                _createVNode(_component_SVG, {
                  name: _ctx.svgNames.downArrow
                }, null, 8, ["name"])
              ]),
              (_ctx.cellSizeDropdownVisible)
                ? (_openBlock(), _createBlock(_component_Dropdown, {
                    key: 0,
                    dropdownItems: null
                  }, {
                    default: _withId(() => [
                      _createVNode("p", null, "Size: " + _toDisplayString(_ctx.cellSize), 1),
                      _createVNode("input", {
                        type: "range",
                        min: "10",
                        max: "30",
                        step: "5",
                        class: "slider",
                        value: _ctx.cellSize,
                        onChange: _cache[5] || (_cache[5] = ($event: any) => (
                                _ctx.$emit(
                                    'update:cellSize',
                                    parseInt($event.target.value)
                                )
                            ))
                      }, null, 40, ["value"])
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true)
            ], 4))
          : _createCommentVNode("", true),
        (_ctx.arraySize)
          ? (_openBlock(), _createBlock("div", {
              key: 1,
              class: "dropdown-container",
              style: 
                        _ctx.arraySizeDropdownVisible ? _ctx.dropdownStyle : _ctx.normalStyle
                    
            }, [
              _createVNode("h1", {
                class: "is-size-4",
                onClick: _cache[6] || (_cache[6] = ($event: any) => (
                            _ctx.arraySizeDropdownVisible = !_ctx.arraySizeDropdownVisible
                        ))
              }, [
                _hoisted_8,
                _createVNode(_component_SVG, {
                  name: _ctx.svgNames.downArrow
                }, null, 8, ["name"])
              ]),
              (_ctx.arraySizeDropdownVisible)
                ? (_openBlock(), _createBlock(_component_Dropdown, {
                    key: 0,
                    dropdownItems: null
                  }, {
                    default: _withId(() => [
                      _createVNode("p", null, "Elements: " + _toDisplayString(_ctx.arraySize), 1),
                      _createVNode("input", {
                        type: "range",
                        min: "5",
                        max: "100",
                        step: "5",
                        class: "slider",
                        value: _ctx.arraySize,
                        onChange: _cache[7] || (_cache[7] = ($event: any) => (
                                _ctx.$emit(
                                    'update:arraySize',
                                    parseInt($event.target.value)
                                )
                            ))
                      }, null, 40, ["value"])
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true)
            ], 4))
          : _createCommentVNode("", true),
        (_ctx.showMazeDropdown)
          ? (_openBlock(), _createBlock("div", {
              key: 2,
              class: "dropdown-container",
              style: _ctx.mazeDropdownVisible ? _ctx.dropdownStyle : _ctx.normalStyle
            }, [
              _createVNode("h1", {
                class: "is-size-4",
                onClick: _cache[8] || (_cache[8] = ($event: any) => (_ctx.mazeDropdownVisible = !_ctx.mazeDropdownVisible))
              }, [
                _hoisted_9,
                _createVNode(_component_SVG, {
                  name: _ctx.svgNames.downArrow
                }, null, 8, ["name"])
              ]),
              (_ctx.mazeDropdownVisible)
                ? (_openBlock(), _createBlock(_component_Dropdown, {
                    key: 0,
                    dropdownItems: _ctx.mazeGenAlgorithmsList,
                    onSelectionChanged: _ctx.mazeGenerationAlgoSelected
                  }, null, 8, ["dropdownItems", "onSelectionChanged"]))
                : _createCommentVNode("", true)
            ], 4))
          : _createCommentVNode("", true)
      ]),
      _createVNode("div", _hoisted_10, [
        (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.buttonsList, (btn) => {
          return (_openBlock(), _createBlock("button", {
            key: btn.text,
            onClick: btn.handler,
            class: { [btn.class]: true },
            style: {"margin-right":"0.5rem"}
          }, _toDisplayString(btn.text), 11, ["onClick"]))
        }), 128))
      ])
    ])
  ]))
})